export const firstPriceRange = (pricingRanges, val = 0) => {
  if (!pricingRanges) return 0;
  let firstNonZero = 0;
  for (let i = 0; i < pricingRanges.length; i++) {
    const range = pricingRanges[i];
    if (range.amount > 0 && firstNonZero === 0) {
      firstNonZero = range.amount;
    }
    if (
      val > range.min &&
      (val <= range.max || range.max === null) &&
      range.amount > 0
    ) {
      return range.amount;
    }
  }
  return firstNonZero;
};

export const itemPerTerm = (planDetails, freq, item = 'MaxUsers') =>
  planDetails[`${freq.toLowerCase()}${item}`];

export default firstPriceRange;



// WEBPACK FOOTER //
// ./src/helpers/billingHelpers.js